"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSlotSchema = exports.CustomerAccountSlotTypeEnumarationValueSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const LexResourceNamePattern = /^([0-9a-zA-Z][_-]?)+$/;
exports.CustomerAccountSlotTypeEnumarationValueSchema = yup_lib_1.default.object().shape({
    value: yup_lib_1.default.string().min(1).max(140).required(),
    synonyms: yup_lib_1.default.array().of(yup_lib_1.default.string().required()).max(10000).notRequired()
});
exports.AccountSlotSchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required(),
    locale: yup_lib_1.default.string().oneOf(data_1.localeCode).required(),
    name: yup_lib_1.default
        .string()
        .matches(LexResourceNamePattern, 'Please enter account slot name consisting Alphabet, Number, _ & -')
        .required()
        .max(100, 'Must be maximum of 100 character'),
    description: yup_lib_1.default.string().optional().min(0).max(200),
    parentType: yup_lib_1.default.string().notRequired(),
    slotTypeValues: yup_lib_1.default.array().when(['parentType'], {
        is: (parentType) => {
            return !parentType;
        },
        then: yup_lib_1.default.array().of(exports.CustomerAccountSlotTypeEnumarationValueSchema).required(),
        otherwise: yup_lib_1.default.array().of(exports.CustomerAccountSlotTypeEnumarationValueSchema).notRequired()
    }),
    valueSelectionStrategy: yup_lib_1.default.string().when(['parentType'], {
        is: (parentType) => {
            return !parentType;
        },
        then: yup_lib_1.default.string().oneOf(data_1.SlotTypeResolutionStrategyArray).required(),
        otherwise: yup_lib_1.default.string().notRequired()
    })
});
